import * as React from 'react';
import {Mutation} from 'react-apollo';
// @ts-expect-error
import type {MutationFunction} from 'react-apollo';

import type {
    UserEmail,
    UpdateSmtpSettings as UpdateSmtpSettingsMutation,
    UpdateSmtpSettingsVariables,
    AttemptToVerifySmtpConnection as AttemptToVerifySmtpConnectionMutation,
    AttemptToVerifySmtpConnectionVariables,
} from 'nutshell-graphql-types';

import {GetEmailSendingSettings} from '../email-sending/get-email-sending-settings';
import ATTEMPT_TO_VERIFY_STMP_CONNECTION from '../graphql/mutations/attempt-to-verify-smtp-connection.graphql';
import UPDATE_SMTP_SETTINGS from '../graphql/mutations/update-smtp-settings.graphql';

class SmtpSettingsUpdate extends Mutation<
    UpdateSmtpSettingsMutation,
    UpdateSmtpSettingsVariables
> {}

class SmtpConnectionAttemptToVerify extends Mutation<
    AttemptToVerifySmtpConnectionMutation,
    AttemptToVerifySmtpConnectionVariables
> {}

type Props = {
    onVerificationPollTimeout?: () => void;
    children: (arg1: {
        isSubmittingSettings: boolean;
        isVerifying: boolean;
        attemptToVerifySmtpConnection: MutationFunction<
            AttemptToVerifySmtpConnectionMutation,
            AttemptToVerifySmtpConnectionVariables
        >;
        updateSmtpSettings: MutationFunction<
            UpdateSmtpSettingsMutation,
            UpdateSmtpSettingsVariables
        >;
        configuredUserEmails: UserEmail[];
        refetchEmails: () => Promise<any>;
    }) => React.ReactElement;
};

export function SubmitSmtpSettings(props: Props) {
    return (
        <SmtpConnectionAttemptToVerify mutation={ATTEMPT_TO_VERIFY_STMP_CONNECTION}>
            {(attemptToVerifySmtpConnection, {loading: isVerifying}) => (
                <SmtpSettingsUpdate mutation={UPDATE_SMTP_SETTINGS}>
                    {(updateSmtpSettings, {loading: isSubmittingSettings}) => (
                        <GetEmailSendingSettings
                            onVerificationPollTimeout={props.onVerificationPollTimeout}
                            pollInterval={1000}
                            pollTimeout={20000}
                        >
                            {({configuredUserEmails, refetch: refetchEmails}) =>
                                props.children({
                                    isSubmittingSettings,
                                    isVerifying,
                                    attemptToVerifySmtpConnection,
                                    updateSmtpSettings,
                                    refetchEmails,
                                    configuredUserEmails,
                                })
                            }
                        </GetEmailSendingSettings>
                    )}
                </SmtpSettingsUpdate>
            )}
        </SmtpConnectionAttemptToVerify>
    );
}
